module.exports = __webpack_public_path__ + "img/sample-logo3.a61bb360.png";